export enum QuestionFormat {
  MARKDOWN = 'markdown',
  CK_HTML = 'ck-html',
  TEXT = 'text',
  RICH_HTML = 'rich-html',
}
